const SMFAbout = () => {
	return (
		<div className="wysiwyg wrapper">
			<p>
				Super Music Fest, efsane isimlerle unutulmaz bir festival deneyimi için CerModern'de sizi
				bekliyor!
			</p>

			<h2>Etkinlik Kuralları</h2>
			<p>
				Festival alanında alışverişlerde nakit ve kredi kartı kullanımı yapılmayıp sadece linkte
				bulunan uygulama üzerinden alışveriş yapılacaktır.
			</p>
			<ol>
				<li>Festival alanına girişler 14.00 itibari ile başlamaktadır.</li>
				<li>
					Etkinlikte yaş sınırı bulunmamaktadır. Her katılımcı bilete tabiidir. 14 yaş altı
					seyirciler alana sadece ebeveynleri ile giriş yapabilir.
				</li>
				<li>
					Festival alanına giriş yapabilmek için kombine veya tek gün bilekliklerinin takılması
					zorunludur. Bileklikler sadece satın alan kişi tarafından kullanılabilir ve başka kişilere
					devredilemez. Ayrıca bilekliklerin kaybedilmesi veya çalınması durumunda yenisi çıkarılmaz
					ve festival alanına tekrar giriş yapılamaz. Etkinlik alanına giriş yapan katılımcıların
					alandan çıkış yapmaları halinde yeni bilet satın almaları gerekecektir.
				</li>
				<li>
					Katılımcıların yaşını doğrulamak amacıyla organizatör festival alanı girişi ve festival
					alanında kimlik/pasaport vb. resmi belge ibrazı isteme hakkını saklı tutar. Tüm
					katılımcıların kimliklerini yanında bulundurması zorunludur.
				</li>
				<li>
					Bilet satın alan tüm katılımcıların güvenlik kontrolünden geçmesi gerekmektedir.
					Organizatör, etkinlik için uygun görmediği kişileri bileti iade etmek kaydıyla içeri
					almama hakkına sahiptir. Festival için bilet satın alan tüm katılımcılar, organizatör ve
					güvenlik önlemlerini kabul etmiş olarak sayılmaktadır. Bu önlemlere uymak istemeyen
					katılımcıların alana giriş hakları iptal edilir ve bilet iadesi yapılmaz.
				</li>
				<li>
					Festival girişinde detaylı üst ve çanta araması yapılacaktır. Etkinlik kurallarına uymayan
					veya güvenliği tehlikeye atan katılımcıların, organizatörlerin kararıyla alandan
					çıkarılması mümkündür.
				</li>
				<li>
					Organizatör, festival programında ve konser başlangıç saatlerinde değişiklik yapma hakkını
					saklı tutar.
				</li>
				<li>
					Etkinlik süresince tüm katılımcıların biletlerini yanlarında bulundurması gerekmektedir.
				</li>
				<li>Festival biletlerinin iade edilmesi veya değiştirilmesi kesinlikle mümkün değildir.</li>
				<li>Organizatör, bilet fiyatlarında değişiklik yapma hakkını saklı tutar.</li>
				<li>
					Festival biletinin çalınması, katılımcı sorumluluğundadır. Çalınan biletin yenisi ile
					değiştirilmesi veya para iadesi mümkün değildir.
				</li>
				<li>
					Festival biletleri sadece organizasyon sahibi tarafından belirlenen resmi satış
					noktalarından alınmalıdır. Organizasyon sahibi resmi satış noktalarından alınmayan
					biletlerin sahiplerini etkinlik alanına almama hakkına sahiptir.
				</li>
				<li>
					Festival biletleri, organizatörün yazılı izni olmadan ticari veya promosyon amacı ile
					kullanılamaz, bir başkasına devredilemez.
				</li>
				<li>
					Festival alanında vegan, vejetaryan ürünler dahil geniş yelpazede yiyecek ve içecek satışı
					mevcut olacağından dışarıdan yiyecek ve içecek getirmek kesinlikte yasaktır.
				</li>
				<li>
					15. Festival alanında 18 yaşı altı satışı yasak olan ürünlerin satışı kesinlikle
					yapılmayacaktır. Bu kapsamda talep eden misafirlerimizin kimlik/pasaport ibrazı
					zorunludur. Festival alanına açılmış açık her türlü tütün ve tütün mamulleri
					alınmamaktadır.
				</li>
				<li>
					Festival süresince profesyonel kayıt yapmak kesinlikle yasaktır. Bu kapsamda, festival
					alanına profesyonel ses ve görüntü araçları (video kamera ve fotoğraf makinesi vb.),
					selfie stick ve GoPro çubukları vb. materyaller alınmayacaktır.
				</li>
				<li>
					Festival alanına yanıcı, patlayıcı (deodorant, sprey, parfüm vb gibi), parlayıcı, kesici
					ve delici olarak kullanılabilecek her türlü alet ve lazer imleci ile girmek yasaktır.
				</li>
				<li>
					Festival alanında IF Performance tarafından sunulan ödeme uygulaması kullanılacaktır.
					Ödeme uygulaması sayesinde festivaldeki tüm satın alımlar, mobil uygulama üzerinden
					gerçekleştirilecektir. Festival alanında organizatör tarafından belirtilen ödeme aracı
					dışında başka bir ödeme aracı geçerli olmayacaktır.
				</li>
				<li>
					Festival alanına katlanabilir sandalye, sehpa ya da şemsiyeler güvenlik tarafından içeri
					alınmamaktadır.
				</li>
				<li>Festival alanına evcil hayvan kabul edilmemektedir.</li>
				<li>
					Festivale giriş sırasında reçetesiz tüm ilaç ve benzeri türevi ürünler alana
					alınmayacaktır.
				</li>
				<li>
					Festival alanında sağlık hizmetleri için ambulanslar ve sağlık görevlileri hazır
					bulunmaktadır.
				</li>
				<li>
					Festivale katılan kişilerin fotoğraf ve video çekimlerinin tanıtım materyallerinde
					kullanım hakkı organizatöre ait olup katılımcı etkinliğe katılarak bu hakkın
					kullanılmasını kabul etmektedir.
				</li>
				<li>
					Etkinlik alanı içinde özel eşyalarınızı yanınızdan ayırmamanız gerekmektedir. Tüm özel
					eşyalarının sorumluluğu katılımcıya aittir.
				</li>
				<li>
					Festival alanındaki ses ve ışık düzenleri geçici duyma ve görme problemlerine yol
					açabilir.
				</li>
				<li>Festival alanında otopark bulunmamaktadır.</li>
				<li>
					Aksi bir durum belirtilmediği sürece festivalin her türlü hava koşulunda gerçekleşmesi
					planlanmaktadır. Konuyla ilgili bilet iadesi yapılmamakla birlikte, bilet alan
					katılımcıların her türlü hava koşuluna hazırlıklı olunması önerilir.
				</li>
				<li>
					Festival alanı dışında katılımcıların yaşayabileceği olumsuz durumlardan (gıda
					zehirlenmesi, yaralanma, adli ve polisiye vakalar vb.) organizatör ve festival güvenliği
					sorumlu tutulamaz.
				</li>
			</ol>
		</div>
	);
};

export default SMFAbout;
